<template>
  <v-card>
    <v-img class="placeholder placeholder__poster" height="250"></v-img>
  </v-card>
</template>

<script>
export default {
  name: "MovieCardPlaceholder",
};
</script>